import { Component, Input, ViewChild, ElementRef, AfterViewInit, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-svg-text',
  templateUrl: './svg-text.component.html',
  styleUrls: ['./svg-text.component.scss'],
})
export class SvgTextComponent implements AfterViewInit, OnChanges {
  @Input() text: string;
  @Input() customClass: string;
  @Input() heightCropFactor = 1; // A value of 1 means no crop, a smaller value (e.g., 0.7) crops more.

  @ViewChild('svgElement') svgElement: ElementRef<SVGElement>;
  @ViewChild('textElement') textElement: ElementRef<SVGTextElement>;

  ngOnChanges(changes: SimpleChanges): void {
    if (
      (changes.text && !changes.text.firstChange) ||
      (changes.heightCropFactor && !changes.heightCropFactor.firstChange)
    ) {
      // Use a timeout to allow the view to update with the new text before measuring
      setTimeout(() => this.adjustSvg(), 0);
    }
  }

  ngAfterViewInit(): void {
    this.adjustSvg();
  }

  private adjustSvg(): void {
    if (!this.svgElement || !this.textElement || !this.text) {
      return;
    }

    const textEl = this.textElement.nativeElement;
    const svgEl = this.svgElement.nativeElement;
    const bbox = textEl.getBBox();

    // This factor "crops" the viewBox vertically to bring the text closer to the edges.
    const croppedHeight = bbox.height * this.heightCropFactor;
    const yOffset = (bbox.height - croppedHeight) / 2;

    const viewBox = `${bbox.x} ${bbox.y + yOffset} ${bbox.width} ${croppedHeight}`;
    svgEl.setAttribute('viewBox', viewBox);
  }
}
